import { render, staticRenderFns } from "./BAlertInfoBox.vue?vue&type=template&id=36dcff52"
import script from "./BAlertInfoBox.vue?vue&type=script&lang=js"
export * from "./BAlertInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports